import React, { useState } from 'react';
import { Settings, ChevronRight } from 'lucide-react';
import { Button } from './Button';
import { getPopupInstructions } from '../../utils/browserDetection'

interface SafariPopupGuideProps {
  onRetry: () => void;
}

export function SafariPopupGuide({ onRetry }: SafariPopupGuideProps) {
  const [showInstructions, setShowInstructions] = useState(true);
  const instructions = getPopupInstructions();

  return (
    <div className="w-full max-w-sm bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 rounded-lg p-4">
      {/* Header */}
      <div className="flex items-start gap-3 mb-3">
        <div className="flex-shrink-0 w-8 h-8 bg-red-100 dark:bg-red-900/40 rounded-full flex items-center justify-center">
          <Settings className="w-4 h-4 mb-0.5 mr-0.5 text-text-primary-light dark:text-text-primary-dark" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-semibold text-text-primary-light dark:text-text-primary-dark mb-1">
            Popups Blocked
          </h3>
          <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark leading-relaxed">
            Safari is blocking the login popup. Follow these steps to enable popups:
          </p>
        </div>
      </div>

      {/* Toggle Instructions Button */}
      <div className="flex flex-col gap-2 mb-3">
        <Button
          variant="outline"
          size="sm"
          fullWidth
          onClick={() => setShowInstructions(!showInstructions)}
          rightIcon={
            <ChevronRight 
              size={14} 
              className={`transition-transform ${showInstructions ? 'rotate-90' : ''}`} 
            />
          }
          className="text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30"
        >
          {showInstructions ? 'Hide Instructions' : 'Show Instructions'}
        </Button>
      </div>

      {/* Step-by-step Instructions */}
      {showInstructions && (
        <div className="mt-4 mb-2">
          <h4 className="text-sm font-medium text-text-primary-light dark:text-text-primary-dark mb-2">
            {instructions.title}
          </h4>
          <ol className="text-xs text-text-secondary-light dark:text-text-secondary-dark space-y-1.5">
            {instructions.steps.map((step, index) => (
              <li key={index} className="flex items-start gap-2">
                <span className=" flex-shrink-0 w-4 h-4 bg-red-200 dark:bg-red-900 text-red-800 dark:text-red-200 rounded-full text-[10px] font-medium flex items-center justify-center mt-0.5">
                <span className='mb-0.3'>{index + 1}</span>
                </span>
                <span className="leading-relaxed">{step}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
} 